import { decode as decodeBase64 } from "universal-base64";
import { destroyCookie } from "nookies";

export default function decodePreviewData(previewOrPreviewID: string | null | undefined, cookies: Record<string, any>) {
  if (!previewOrPreviewID) {
    return null;
  }

  try {
    const shardedPreviewKeys = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((index) => {
      const shardID = encodeURIComponent(`${previewOrPreviewID}/${index}`);
      return shardID;
    });
    const shardedPreviewData = shardedPreviewKeys
      .map((shardKey) => (cookies && cookies[shardKey] ? decodeURIComponent(cookies[shardKey]) : ""))
      .filter(Boolean)
      .join("");

    // Erase all cookies
    shardedPreviewKeys.forEach((key) => {
      destroyCookie(null, key);
    });

    return JSON.parse(decodeBase64(shardedPreviewData || previewOrPreviewID)) as Record<string, any>;
  } catch {
    // console.log(e);
    return null;
  }
}
